/**
 * Detects iOS (including iPadOS 13+, which reports a desktop Safari user
 * agent and is only distinguishable via the touch-point fallback below).
 */
export function isIOS() {
  if (typeof navigator === "undefined") return false;

  const userAgent = navigator.userAgent || "";
  if (/iPad|iPhone|iPod/.test(userAgent)) return true;

  return navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
}
